import * as Yup from "yup"

export const enterpriseSchema = Yup.object({
  name: Yup.string()
    .required("Le nom de l'entreprise est requis")
    .max(100, "Le nom ne peut excéder 100 caractères"),
  code: Yup.string()
    .required("Le code est requis")
    .matches(
      /^[A-Z0-9_]+$/,
      "Le code ne peut contenir que des lettres majuscules, chiffres et underscores"
    )
    .max(15, "Le code ne peut excéder 15 caractères"),
  packagingNotes: Yup.string().max(1000, "Maximum 1000 caractères"),
  cardDesignNotes: Yup.string().max(1000, "Maximum 1000 caractères"),
  requiresValidation: Yup.boolean(),
})

export const enterpriseInitialValues = {
  name: "",
  code: "",
  packagingNotes: "",
  cardDesignNotes: "",
  requiresValidation: true,
}
